import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'

function resolveLastEligibleSlot(combatant, maxCA) {
  const configuredCA = Number(combatant?.ca)

  if (Number.isFinite(configuredCA) && configuredCA >= 1) {
    return Math.min(configuredCA, maxCA)
  }

  return maxCA
}

function getLastRoundActionFromSlots(combatant, maxCA) {
  // Loop through the combatant's entitled round slots in reverse order and use the
  // last occupied slot, whether it contains an action or a marker/counter.
  const lastEligibleSlot = resolveLastEligibleSlot(combatant, maxCA)

  for (let actionNum = lastEligibleSlot; actionNum >= 1; actionNum--) {
    const imageField = 'ca' + actionNum
    const nameField = 'ca_name' + actionNum
    const typeField = 'ca_type' + actionNum

    console.log(
      'actionNum = ',
      actionNum,
      ' / typeField = ',
      typeField,
      ' / combatant[typeField] = ',
      combatant[typeField],
    )

    const slotType = combatant[typeField]
    const slotName = combatant[nameField]

    if (
      (slotType == 'action' || slotType == 'marker') &&
      slotName != 'pending' &&
      slotName != 'blank'
    ) {
      console.log('got image')
      return {
        image: combatant[imageField],
        name: slotName,
        action: slotType == 'action' ? (getAction(slotName) ?? null) : null,
      }
    }
  }

  return null
}

function getLastRoundActionFromCollection(combatant, maxCA, currentRound) {
  if (!Number.isFinite(currentRound) || !Array.isArray(combatant?.actions)) {
    if (!Array.isArray(combatant?.markers)) {
      return null
    }
  }

  const lastEligibleSlot = resolveLastEligibleSlot(combatant, maxCA)

  const actionEntries = (Array.isArray(combatant?.actions) ? combatant.actions : [])
    .filter(
      (action) =>
        action?.round === currentRound &&
        Number.isFinite(action?.number) &&
        action.number >= 1 &&
        action.number <= lastEligibleSlot &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank',
    )
    .map((action) => ({
      number: action.number,
      image: action.action_image || blankAction,
      name: action.action_name,
      action: getAction(action.action_name) ?? null,
    }))

  const markerEntries = (Array.isArray(combatant?.markers) ? combatant.markers : [])
    .filter(
      (marker) =>
        marker?.round === currentRound &&
        Number.isFinite(marker?.number) &&
        marker.number >= 1 &&
        marker.number <= lastEligibleSlot &&
        marker?.marker_name !== 'pending' &&
        marker?.marker_name !== 'blank',
    )
    .map((marker) => ({
      number: marker.number,
      image: marker.marker_image || blankAction,
      name: marker.marker_name,
      action: null,
    }))

  const lastEntry = [...actionEntries, ...markerEntries].sort(
    (left, right) => right.number - left.number,
  )[0]

  if (!lastEntry) {
    return null
  }

  return lastEntry
}

export default function getCombatantLastRoundAction(combatant, maxCA, currentRound = null) {
  console.log('----------------------------------------------------------------------------------')
  console.log('IN getCombatantLastRoundAction combatant = ', combatant.name, ' maxCA = ', maxCA)

  console.log('combatant snapshot = ', JSON.parse(JSON.stringify(combatant)))

  const slotAction = getLastRoundActionFromSlots(combatant, maxCA)

  if (slotAction) {
    return slotAction
  }

  const collectionAction = getLastRoundActionFromCollection(combatant, maxCA, currentRound)

  if (collectionAction) {
    console.log('got image from actions collection')
    return collectionAction
  }

  console.log('gonna be blank image')
  return {
    image: blankAction,
    name: 'blank',
    action: null,
  }
}
